import { render, staticRenderFns } from "./DsMoveSelector.vue?vue&type=template&id=c6582c14&scoped=true"
import script from "./DsMoveSelector.vue?vue&type=script&lang=js"
export * from "./DsMoveSelector.vue?vue&type=script&lang=js"
import style0 from "./DsMoveSelector.vue?vue&type=style&index=0&id=c6582c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6582c14",
  null
  
)

export default component.exports